export default __webpack_public_path__ + "static/FTRegolaNeue-Medium-c50e1e6b22cab7cd59e3266dbef618f8.woff2";